import { Alert, Select } from "antd";
import { Modal } from "antd";
import { getAllAcademicYear } from "../../api/generalParam";
import { toast } from "sonner";
import { useEffect, useState } from "react";

type Props = {
  showModal: boolean;
  setShowModal: (show: boolean) => void;
  error: string;
  setError: (error: string) => void;
  cycles: any[];
  cycle: string;
  setCycle: (cycle: string) => void;
  selectedYears: any[];
  setSelectedYears: (years: any[]) => void;
  setPromotionYears: (years: any[]) => void;
};

const ModalPromotion = ({
  showModal,
  setShowModal,
  error,
  setError,
  cycles,
  cycle,
  setCycle,
  selectedYears,
  setSelectedYears,
  setPromotionYears,
}: Props) => {
  const [allAcademicYears, setAllAcademicYears] = useState<any[]>([]);
  const [selectedCycle, setSelectedCycle] = useState<string>("");

  const fetchAllAcademicalYears = async () => {
    try {
      const response = await getAllAcademicYear();

      const data = response.data;
      //   console.log("All academic years:", data);
      setAllAcademicYears(data);
      return data;
    } catch (error: any) {
      // console.log("erreur récupération des années académiques: ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );

      return [];
    }
  };

  // 🔹 Validation de la sélection
  const handleValidatePromotion = () => {
    if (!selectedCycle || selectedYears.length === 0) {
      setError("Veuillez choisir un cycle et sa derniere année scolaire.");
      return;
    }

    setCycle(selectedCycle);
    setPromotionYears([...selectedYears].sort());
    setError("");
    setShowModal(false);
  };

  useEffect(() => {
    if (!showModal) return;
    setSelectedCycle(cycle);
    fetchAllAcademicalYears();
  }, [showModal]);

  return (
    <Modal
      title="Sélectionner une promotion"
      open={showModal}
      onCancel={() => {
        setShowModal(false);
        setError("");
      }}
      onOk={(e) => {
        handleValidatePromotion();
      }}
      okText="Valider"
    >
      <div className="d-flex flex-column gap-3">
        <div>
          <label>Cycle</label>
          <Select
            value={selectedCycle}
            aria-placeholder="Selectionner un cycle"
            onChange={(value, option) => {
              const matchCycle = cycles.find((c) => c?.id === value);
              // console.log("SelectedCycle: ", matchCycle);

              if (matchCycle) setSelectedCycle(matchCycle);
              setSelectedYears([]);
              setError("");
            }}
            style={{ width: "100%" }}
            placeholder="Choisir le cycle"
          >
            <Select.Option value={""}>Selectionner un cycle</Select.Option>
            {cycles.map((c, idx) => (
              <Select.Option key={idx} value={c?.id}>
                {c?.label}
              </Select.Option>
            ))}
          </Select>
        </div>

        {selectedCycle && (
          <div>
            <label>Derniere Année scolaire du cycle</label>
            <Select
              // mode="multiple"
              style={{ width: "100%" }}
              placeholder="Sélectionner la derniere années scolaire"
              value={selectedYears.map((y) => y.id)}
              onChange={(ids) => {
                const selected = allAcademicYears.filter((year) =>
                  ids.includes(year.id),
                );
                setSelectedYears(selected);
                setError("");
              }}
            >
              {allAcademicYears
                .sort((a, b) => a.startDate.localeCompare(b.startDate))
                .map((year: any) => (
                  <Select.Option key={year.id} value={year.id}>
                    {year.label}
                  </Select.Option>
                ))}
            </Select>

            {/* Message d'erreur */}
            {error && (
              <Alert
                message={error}
                type="error"
                showIcon
                style={{ marginTop: 10 }}
              />
            )}
          </div>
        )}
      </div>
    </Modal>
  );
};

export default ModalPromotion;
